/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMemberFieldTypes } from './WebApiModelsEnumerationTypesMemberFieldTypes';
import {
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSON,
    WebApiModelsEnumerationTypesMemberFieldTypesFromJSONTyped,
    WebApiModelsEnumerationTypesMemberFieldTypesToJSON,
} from './WebApiModelsEnumerationTypesMemberFieldTypes';
import type { WebApiModelsEnumerationTypesUiControl } from './WebApiModelsEnumerationTypesUiControl';
import {
    WebApiModelsEnumerationTypesUiControlFromJSON,
    WebApiModelsEnumerationTypesUiControlFromJSONTyped,
    WebApiModelsEnumerationTypesUiControlToJSON,
} from './WebApiModelsEnumerationTypesUiControl';

/**
 * 
 * @export
 * @interface WebApiMemberFieldsDtoAddMemberFieldDto
 */
export interface WebApiMemberFieldsDtoAddMemberFieldDto {
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberFieldTypes}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    columnType?: WebApiModelsEnumerationTypesMemberFieldTypes;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    nameAdmin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    namePublic?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    visibleInAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    visiblePublic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    mandatoryAdmin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    mandatoryPublic?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    helpTextAdmin?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    helpTextPublic?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    columnOrder?: number | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesUiControl}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    uiControl?: WebApiModelsEnumerationTypesUiControl;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    alternatives?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberFieldsDtoAddMemberFieldDto
     */
    customListId?: number | null;
}

/**
 * Check if a given object implements the WebApiMemberFieldsDtoAddMemberFieldDto interface.
 */
export function instanceOfWebApiMemberFieldsDtoAddMemberFieldDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberFieldsDtoAddMemberFieldDtoFromJSON(json: any): WebApiMemberFieldsDtoAddMemberFieldDto {
    return WebApiMemberFieldsDtoAddMemberFieldDtoFromJSONTyped(json, false);
}

export function WebApiMemberFieldsDtoAddMemberFieldDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberFieldsDtoAddMemberFieldDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'columnType': !exists(json, 'columnType') ? undefined : WebApiModelsEnumerationTypesMemberFieldTypesFromJSON(json['columnType']),
        'nameAdmin': !exists(json, 'nameAdmin') ? undefined : json['nameAdmin'],
        'namePublic': !exists(json, 'namePublic') ? undefined : json['namePublic'],
        'visibleInAdmin': !exists(json, 'visibleInAdmin') ? undefined : json['visibleInAdmin'],
        'visiblePublic': !exists(json, 'visiblePublic') ? undefined : json['visiblePublic'],
        'mandatoryAdmin': !exists(json, 'mandatoryAdmin') ? undefined : json['mandatoryAdmin'],
        'mandatoryPublic': !exists(json, 'mandatoryPublic') ? undefined : json['mandatoryPublic'],
        'helpTextAdmin': !exists(json, 'helpTextAdmin') ? undefined : json['helpTextAdmin'],
        'helpTextPublic': !exists(json, 'helpTextPublic') ? undefined : json['helpTextPublic'],
        'columnOrder': !exists(json, 'columnOrder') ? undefined : json['columnOrder'],
        'uiControl': !exists(json, 'uiControl') ? undefined : WebApiModelsEnumerationTypesUiControlFromJSON(json['uiControl']),
        'alternatives': !exists(json, 'alternatives') ? undefined : json['alternatives'],
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
    };
}

export function WebApiMemberFieldsDtoAddMemberFieldDtoToJSON(value?: WebApiMemberFieldsDtoAddMemberFieldDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'columnType': WebApiModelsEnumerationTypesMemberFieldTypesToJSON(value.columnType),
        'nameAdmin': value.nameAdmin,
        'namePublic': value.namePublic,
        'visibleInAdmin': value.visibleInAdmin,
        'visiblePublic': value.visiblePublic,
        'mandatoryAdmin': value.mandatoryAdmin,
        'mandatoryPublic': value.mandatoryPublic,
        'helpTextAdmin': value.helpTextAdmin,
        'helpTextPublic': value.helpTextPublic,
        'columnOrder': value.columnOrder,
        'uiControl': WebApiModelsEnumerationTypesUiControlToJSON(value.uiControl),
        'alternatives': value.alternatives,
        'customListId': value.customListId,
    };
}

